import {
  OPERATOR_FETCH_REQUEST,
  OPERATOR_FETCH_REQUEST_SUCCESS,
  OPERATOR_FETCH_REQUEST_FAILURE,
  OPERATOR_ADD_REQUEST,
  OPERATOR_ADD_REQUEST_SUCCESS,
  OPERATOR_ADD_REQUEST_FAILURE,
  OPERATOR_UPDATE_REQUEST,
  OPERATOR_UPDATE_REQUEST_SUCCESS,
  OPERATOR_UPDATE_REQUEST_FAILURE,
  OPERATOR_COUNT_FETCH_REQUEST,
  OPERATOR_COUNT_FETCH_REQUEST_SUCCESS,
  OPERATOR_COUNT_FETCH_REQUEST_FAILURE,
  OPERATOR_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const operatorsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case OPERATOR_FETCH_REQUEST:
    case OPERATOR_ADD_REQUEST:
    case OPERATOR_UPDATE_REQUEST:
    case OPERATOR_COUNT_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case OPERATOR_FETCH_REQUEST_SUCCESS:
    case OPERATOR_ADD_REQUEST_SUCCESS:
    case OPERATOR_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case OPERATOR_COUNT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case OPERATOR_FETCH_REQUEST_FAILURE:
    case OPERATOR_ADD_REQUEST_FAILURE:
    case OPERATOR_UPDATE_REQUEST_FAILURE:
    case OPERATOR_COUNT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case OPERATOR_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default operatorsReducer;
